import storeE from "../../../store";

export const validateStep1 = () => {
    const newState = storeE.getState();
    const val = newState.step1Validation;
    return val.ConfidentialityValid.isValid && val.TemplateValid.isValid && val.ExternalValid.isValid;
}

export const validate1 = () => {
    const newState = storeE.getState();
    const site = newState.newSite;
    return !!site.Confidentiality && !!site.Template && site.ExternalCollaboration !== null;

}


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/Validator.js